import { createTheme } from "@mui/material";
import { Form, Formik } from "formik";
import MUIDataTable from "mui-datatables";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { userid } from "../../Common/Credentials";
import { spin } from "../../Common/NewLoader";
import { appmasterid } from "../../Common/Permissions";
import CustomToolbar from "../../CommonComponents/CustomToolbar";
import Footer from "../../Component/Footer";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import { ThemeProvider, Tooltip } from "@mui/material";
import MasterService from "../MasterService";
import { FormikTextField } from '../../CommonComponents/FormField.js';
import { Spinner } from "react-bootstrap";

import deleteIcon from "../../images/Icons/delete.png";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, "solid", "#ece6e6"]],
      },
      body: {
        border: [[1, "solid", "#ece6e6"]],
      },
    },
  },
});

class Products extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ProductsList: [],
      product: '',
      newproduct: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }
  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.refresh()
  }
  refresh() {
    MasterService.getAllProducts().then((response) => {
      this.setState({ ProductsList: response.data, newproduct: false })
    })
  }

  onSubmit() {
    MasterService.addproduct(this.state.product).then((response) => this.refresh())
  }
  validate(values) {
    let errors = {};
    if (this.state.product === '') {
      errors.product = "Please Enter Product";
    }
    return errors;
  }
  render() {
    let { product } = this.state
    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          sort: false,
          display: false,
          sortOrder: "desc",
        },
      },
      {
        name: "products",
        label: "Product",
        options: { filter: true, sort: true },
      },
      {
        name: "Delete",
        options: {
          filter: false,
          sort: false,
          empty: true,
          display: appmasterid === "2" || appmasterid === "3" ? true : false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <Tooltip title="Delete">
                <img
                  src={deleteIcon}
                  alt="Delete"
                  style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }}
                  onClick={() => {
                    const id = tableMeta.rowData.find((e) => e);
                    if (window.confirm(`Are you sure you wish to delete Screen ${id}?`)) {
                      this.deleteScreen(id);
                    }
                  }}
                />
              </Tooltip>
            );
          },

        },
      },
    ];

    const options = {
      filterType: "checkbox",
      selectableRows: "none",
      customToolbar: () => {
        return (
          <>
            {appmasterid === "2" || appmasterid === "3" ? (
              <span
                as="button"
                className="float-right btn btn-sm m-0 p-0"
                onClick={() => this.setState({ newproduct: true })}
              >
                <CustomToolbar />
              </span>
            ) : (
              ""
            )}
          </>
        );
      },
    };
    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
        <div className='UI-container'>
        <div className={`UI-header`}>
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"Prooducts",path:null}]}/>
        </div>
                    <div className="UI-form-card ">
                  {this.state.loading === true ? (
                    <div className="text-center">{spin}</div>
                  ) : (<>
                     {this.state.newproduct && <Formik
                      initialValues={{ product }}
                      onSubmit={this.onSubmit}
                      validateOnChange={false}
                      validate={this.validate}
                      enableReinitialize={true}>
                      {({ setFieldValue, values }) => (
                        <Form autoComplete="off">
                          <div className="form-row">
                              <fieldset className="form-group col-md-4">
                                <TextfieldComponent type="text" name="product" value={this.state.screen} label="Product" onChange={(e) => this.setState({ product: e.target.value})}/>
                              </fieldset>
                              <fieldset className="col-md-4 tw-flex tw-items-center">
                                {this.state.loader === true ? <button className="btn btn-sm hovbuttonColour tw-py-2 tw-px-4" disabled><Spinner animation="border" size="sm" />&nbsp;{"Saving"}</button> : <button className="btn btn-sm hovbuttonColour tw-py-2 tw-px-4" type="submit">Save</button>}
                                <span as="button" className="btn btn-sm tw-border-[#4d4d4d] tw-borde-2 tw-bg-white ml-1 tw-py-2 tw-px-4" onClick={() => this.setState({ newproduct: false })} > Cancel</span>
                              </fieldset>
                          </div>
                        </Form>
                      )}
                    </Formik>}
                    <ThemeProvider theme={theme}>
                      <MUIDataTable
                        className="table-sm"
                        title={"products"}
                        data={this.state.ProductsList}
                        columns={columns}
                        options={options}
                      />
                    </ThemeProvider>
                  </>)}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(Products);
